import { render, staticRenderFns } from "./ShareMyCard.vue?vue&type=template&id=1afa980c&"
import script from "./ShareMyCard.vue?vue&type=script&lang=js&"
export * from "./ShareMyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports